module.exports = __webpack_public_path__ + "static/media/accessory__ultrasonicSensor.23404a45.jpg";